import { useEffect, useState } from 'react';

async function fetchAppVersion(): Promise<string> {
  if (process.env.APP_VERSION) return process.env.APP_VERSION;

  try {
    // @ts-ignore
    const base = import.meta.env?.BASE_URL || process.env.PUBLIC_URL || '/';
    const res = await fetch(`${base}version.json`, { cache: 'no-store' });
    const data = (await res.json()) as { version: string };
    return data.version;
  } catch {
    return '';
  }
}

let cached: string | undefined;

export const useAppVersion = (): string | undefined => {
  const [version, setVersion] = useState<string | undefined>(cached);

  useEffect(() => {
    if (cached !== undefined) {
      setVersion(cached);
      return;
    }
    fetchAppVersion().then((v) => {
      cached = v;
      setVersion(v);
    });
  }, []);

  return version;
};
